export default __webpack_public_path__ + "static/media/img-0752-romania-premium-face.3ab9522d.png";